import radioChannels from "./Channels";

function ButtonChannels({
  nameOfStation,
  setNameOfStation,
  setImgOfStation,
  setLinkOfStation,
  setId,
}) {
  return (
    <div className="grid md:px-10">
      <div className="btn-group dropup justify-end p-3">
        <button
          type="button"
          className="duration-500 text-[#f0ffff] 
              border-0 rounded-lg border-black led_box"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <span className="Button uppercase rounded-md py-1 px-3">Radio</span>
        </button>
        {/* Listado de botones */}
        <ul className="dropdown-menu bg-black shadowMarginDropMenu">
          {radioChannels.map((channel, i) => (
            <button
              className="flex uppercase duration-500 py-1 active:origin-center 
                  transition delay-150 hover:delay-0 led_button rounded-md 
                  text-[#f0ffff] hover:text-[rgb(240,255,255)] mx-auto my-3"
              key={i}
              onClick={() => {
                setNameOfStation(channel.name);
                setImgOfStation(channel.img);
                setLinkOfStation(channel.link);
                setId(channel.id);
              }}
            >
              {channel.name}
            </button>
          ))}
        </ul>
      </div>
      <span className="text-sm text-white text-center">{nameOfStation} 
      <br className="md:hidden"/>{" "}on air.</span>
    </div>
  );
}

export default ButtonChannels;
